<template>
  <section class="insurance-consult-advance">
    <div class="insurance-consult-advance__content">
      <DsTextSplit
        as="h3"
        base="Consulta el avance de "
        highlight="tu solicitud"
        baseColor="#1F1F77"
        highlightColor="#6D59EA"
      />

      <DsText as="body3" class="insurance-consult-advance__description">
        Selecciona una opción para conocer los requisitos y pasos que debes seguir.
      </DsText>

      <div class="insurance-consult-advance__fields">
        <DsInputText
          v-model="contractNumber"
          label="Número de contrato"
          placeholder="Ingresa Numero de contrato"
        />

        <DsInputText
          v-model="claimFile"
          label="Folio del siniestro"
          placeholder="Ingresa folio del siniestro"
        />
      </div>

      <DsButton
        class="insurance-consult-advance__button"
        variant="outlined"
        size="large"
      >
        Consultar estatus
      </DsButton>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import DsButton from '../atoms/DsButton.vue'
import DsInputText from '../atoms/DsInputText.vue'
import DsText from '../atoms/DsText.vue'
import DsTextSplit from '../atoms/DsTextSplit.vue'

const contractNumber = ref('')
const claimFile = ref('')
</script>

<style scoped>
.insurance-consult-advance {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding: 24px 16px;
  overflow: hidden;
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border-radius: 24px;
  background: #FFFFFF;
}


.insurance-consult-advance__description {
  color: #1F1F1F;
  max-width: 600px;
  padding: 4px 0;
}

.insurance-consult-advance__fields {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.insurance-consult-advance__button {
  display: flex;
  width: 50%;
  min-width: 0;
  margin: 16px auto 0;
}

@media (max-width: 1024px) {
  .insurance-consult-advance__button {
    width: 100%;
    min-width: 0;
    margin: 16px 0 0;
  }
}



@media (max-width: 768px) {
  .insurance-consult-advance { padding: 16px; border-radius: 16px; }
  .insurance-consult-advance__content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0;
    border-radius: 0;
  }

  .insurance-consult-advance__fields {
    max-width: none;
    gap: 16px;
  }

  .insurance-consult-advance__fields :deep(.ds-input-text) { gap: 4px; }
  .insurance-consult-advance__fields :deep(.ds-input-text__label) { padding: 0; line-height: 24px; }
  .insurance-consult-advance__fields :deep(.ds-input-text__field) { padding: 13px 16px; }

  .insurance-consult-advance__button {
    width: 100%;
    min-width: 0;
    min-height: 48px;
    margin: 0;
    border-radius: 24px;
  }
}

@media (min-width: 600px) and (max-width: 767px) {
  .insurance-consult-advance { padding: 24px; }
  .insurance-consult-advance__content { gap: 16px; }

  .insurance-consult-advance__button {
    width: 340px;
    margin: 0 auto;
  }
}
</style>
